var _defs, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconHelp = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .help_a,\n            .help_c {\n                fill: none !important;\n            }\n\n            .help_a {\n                stroke: #fff;\n                stroke-linecap: round;\n                stroke-linejoin: round;\n                stroke-width: 2px;\n            }\n\n            .help_b {\n                fill: #fff;\n                fill-rule: evenodd;\n            }\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5639.5 5120.173)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5623 -5108.673)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "help_a",
    d: "M18,23.063V18",
    transform: "translate(-18 -12.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "help_a",
    d: "M18,12h0",
    transform: "translate(-18 -12)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "help_b",
    d: "M95,637a11,11,0,1,0-11,11A11,11,0,0,0,95,637Zm-20.167,0A9.167,9.167,0,1,1,84,646.167,9.167,9.167,0,0,1,74.833,637Z",
    transform: "translate(-5707 -5740.673)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "help_c",
    width: 32,
    height: 32
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconHelp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_help.d65c85c986ada0011a1f356551416453.svg";